import React, { FC, HTMLAttributes } from "react";
import "./Scrollable.css";

/**
 * Conteneur scrollable en CSS natif (overflow: auto).
 * Remplace react-custom-scrollbars (déprécié/archivé).
 * La prop autoHide est acceptée pour compatibilité, le style est géré via CSS.
 */
export const Scrollable: FC<
  {
    autoHide?: boolean;
  } & HTMLAttributes<HTMLDivElement>
> = ({ autoHide, style, className, children, ...rest }) => {
  const mergedClassName = ["scrollable", className].filter(Boolean).join(" ");

  return (
    <div
      className={mergedClassName}
      style={{ overflow: "auto", ...style }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Scrollable;
